<template>
  <section class="w">
    <slot></slot>
  </section>
</template>
<script>
export default {
  name: 'wrapper'
}
</script>
<style lang="scss" scoped>
.w {
  margin: 0.2rem 0.24rem;
  border-radius: 0.16rem;
  background-color: #ffffff;
  padding: 0.18rem 0.24rem;
}
</style>
